import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import { EMPTY_OBJECT } from './AddTaskList'

function DeleteCube(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [databaseId, setDatabaseId] = useState(-1)
    const [sqLDbList, setSqLDbList] = useState([])
    const [ssasServers, setSsasServers] = useState([])
    const [ssasDataSources, setSsasDataSources] = useState([])
    const [selectedSsasDataSource, setSelectedSsasDataSource] = useState('')

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 1)
            setSqLDbList(dBList)
        }

        if (ssasServers.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 1)
            setSsasServers(dBList)
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            if (props.taskData.databaseId !== databaseId) {
                setDatabaseId(props.taskData.databaseId)
                setIsLoadingRequest(true)
                setSelectedSsasDataSource('')
            
                let getDataSources = props.getDataSources(props.taskData.databaseId)
                getDataSources.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    const ssasSourceLookup = json.filter(x => x.key === props.taskData.dataSourceSystemName)
                    let dataSourceSystemNameToSet = ''
                    if (ssasSourceLookup.length === 0) {
                        const ssasSourceNameLookup = json.filter(x => x.value === props.taskData.databaseName)
                        if (ssasSourceNameLookup.length > 0) {
                            dataSourceSystemNameToSet = ssasSourceNameLookup[0].key
                        }
                    } else {
                        dataSourceSystemNameToSet = ssasSourceLookup[0].key
                    }

                    setIsLoadingRequest(false)
                    setSsasDataSources(json)
                    setSelectedSsasDataSource(dataSourceSystemNameToSet)
                }).catch((ex) => {
                    console.error(ex)
                    setIsLoadingRequest(false)
                    setSsasDataSources([])
                })
            }
        } else {
            setDatabaseId(-1)
            setSelectedSsasDataSource('')
        }
    }, [props.taskData.databaseId, props.taskData.dataSourceSystemName, props.taskData.databaseName])

    function handleSsasServer(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setIsLoadingRequest(true)
        setSelectedSsasDataSource('')
        fireOnSaveEvent(event.target.value, '', '')

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)
            setSsasDataSources(json)
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
            setSsasDataSources([])
        })
    }

    function handleSsasDataSourceChange(event) {
        event.preventDefault()
        setSelectedSsasDataSource(event.target.value)

        let lookup = null
        for (let x = 0; x < ssasDataSources.length; x++) {
            if (ssasDataSources[x]["key"] === event.target.value) {
                lookup = ssasDataSources[x]
            }
        }

        if (lookup) {
            fireOnSaveEvent(databaseId, lookup["value"], lookup["key"])
        }
    }

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dbSsasId - SSAS Database ID
     */
    function fireOnSaveEvent(dbId, dbName, dbSsasId) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceSystemName"] = dbSsasId
            props.onSave(copied)
        }
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Delete Cube</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-ssas-database-server-label">SSAS Database Server</InputLabel>
                <Select
                    labelId="select-ssas-database-server-label"
                    id="select-ssas-database-server"
                    label="SSAS Database Server"
                    onChange={handleSsasServer}
                    defaultValue={ssasServers.length > 0 ? ssasServers[0].id : -1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select SSAS Database Server</MenuItem>
                        { ssasServers.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-ssas-database-label">SSAS Cube</InputLabel>
                <Select
                    labelId="select-ssas-database-label"
                    id="select-ssas-database"
                    label="Select SSAS Data Source"
                    onChange={handleSsasDataSourceChange}
                    value={selectedSsasDataSource}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select SSAS Data Source</MenuItem>
                        { ssasDataSources.map((x, i) => x && <MenuItem key={`${i}-${x.key}`} value={x.key}>{x.value}</MenuItem>) }
                </Select>
            </FormControl>
        </Paper>
    )
}

export default DeleteCube